export const ACCOUNT_KEY = '@inter-cdpro/account-data'

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'
